<template>
  <div class="container">
    <div class="con">
      <cart-top></cart-top>
      <router-view></router-view>

    </div>
  </div>
</template>

<script>
import cartTop from './components/cart-top.vue';
import cartGoodsList from './components/cart-goodsList.vue';

export default {
  components:{cartTop,cartGoodsList},
  data(){
    return{

    }
  }
}
</script>

<style lang="scss" scoped>
  .con{
    overflow: hidden;
    min-height: calc(100vh - 142px);
      // height: calc(100vh - 32px - 110px);
  }
</style>


// WEBPACK FOOTER //
// src/pages/cart/index.vue